export const LEGAL_LINKS = [
  { href: 'https://semrel.io/legal/terms/', label: 'Terms' },
  { href: 'https://semrel.io/legal/privacy/', label: 'Privacy' },
  { href: 'https://semrel.io/legal/imprint/', label: 'Imprint' },
] as const;
